// assets/ppl-gallery-arrows.js
(function () {
  function getThumbButtons(galleryEl) {
    const list = galleryEl.querySelector('.thumbnail-slider .thumbnail-list');
    if (!list) return [];
    return Array.from(list.querySelectorAll('button.thumbnail'));
  }

  function getCurrentIndex(btns) {
    return btns.findIndex((b) => b.getAttribute('aria-current') === 'true');
  }

  function clickIndex(btns, idx) {
    if (idx < 0 || idx >= btns.length) return;
    btns[idx].click();
  }

  document.addEventListener(
    'click',
    function (e) {
      const arrow = e.target.closest('.ppl-galleryArrow');
      if (!arrow) return;

      const gallery = arrow.closest('media-gallery');
      if (!gallery) return;

      const btns = getThumbButtons(gallery);
      if (!btns.length) return;

      const dir = arrow.classList.contains('ppl-galleryArrow--prev') ? -1 : 1;
      const cur = getCurrentIndex(btns);
      const next = cur === -1 ? 0 : cur + dir;

      // loop
      if (next < 0) return clickIndex(btns, btns.length - 1);
      if (next >= btns.length) return clickIndex(btns, 0);
      clickIndex(btns, next);
    },
    false
  );
})();
